// extracted by mini-css-extract-plugin
export default {"page":"Di-z","cartModal":"Ei-z","checkout":"Fi-z","placeholder":"Gi-z","account":"Hi-z"};